// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from copy.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function CopyIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd" fill="none">
        <path d="M0 0h16v16H0z" />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 15H1V5h3m11-4v10H7V1h8z"
        />
      </g>
    </svg>
  );
}
